<template>
    <v-autocomplete
        :items="items"
        :label="label"
        class="timezone-input"
        dense
        item-text="label"
        item-value="timezone"
        outlined
        v-bind="$attrs"
        @change="$emit('change')"
        v-on="$listeners"
    >
    </v-autocomplete>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: false,
            default: String,
        },
        current: {
            type: Object,
            required: false,
            default: () => {
                return null;
            },
        },
    },
    data() {
        return {
            items: [],
        };
    },
    created() {
        this.loadTimezones();
    },
    methods: {
        clear() {
            this.$emit('clear');
        },
        loadTimezones() {
            axios.get(route('api.v1.timezones')).then((response) => {
                this.items = response.data;
            });
        },
    },
};
</script>

<style scoped></style>
